import {
  EnvelopeIcon,
  EyeIcon,
  BuildingOffice2Icon,
  PhoneIcon,
  BriefcaseIcon,
  CurrencyEuroIcon,
} from "@heroicons/react/24/outline";
import logo from "../../../assets/logo-nanthiat.png"; // ajuste le chemin si besoin

export default function ProspectProfile({ prospect, onViewDetails }) {
  const isPM = prospect?.type === "Personne Morale";

  return (
    <div className="flex flex-col justify-between bg-white shadow-md rounded-lg p-6 h-[300px] w-[400px]">
      {/* 🔹 Titre visible uniquement si aucun prospect n’est sélectionné */}
      {!prospect && (
        <h2 className="text-xl font-semibold text-center text-gray-800 mb-4">Profil</h2>
      )}

      {!prospect ? (
        <div className="flex-1 flex flex-col items-center justify-center text-center space-y-4">
          <img src={logo} alt="Logo Nanthiat" className="w-20 h-20" />
          <p className="text-gray-500">Sélectionnez un prospect pour voir ses informations.</p>
        </div>
      ) : (
        <>
          {/* Profil du Prospect */}
          <div className="flex items-center pl-4">
            <div className="w-24 h-24 flex items-center justify-center bg-gray-200 rounded-full text-2xl font-bold">
              {prospect.prenom?.charAt(0) || ""}{prospect.nom?.charAt(0) || ""}
            </div>

            <div className="pl-8">
              <h3 className="text-lg font-semibold text-gray-800">
                {prospect.prenom} {prospect.nom}
              </h3>

              <div className="flex items-center gap-2 mt-1">
                <BriefcaseIcon className="w-5 h-5 text-gray-500" />
                <p className="text-gray-600">
                  {isPM
                    ? prospect.secteurActivite || "Secteur non renseigné"
                    : prospect.profession || "Profession non renseignée"}
                </p>
              </div>

              <div className="flex items-center gap-2 mt-1">
                <PhoneIcon className="w-5 h-5 text-gray-500" />
                <p className="text-gray-600">{prospect.telephone || "Téléphone non renseigné"}</p>
              </div>

              <div className="flex items-center gap-2 mt-1">
                <EnvelopeIcon className="w-5 h-5 text-gray-500" />
                <p className="text-gray-600">{prospect.email || "Email non renseigné"}</p>
              </div>

              <div className="flex items-center gap-2 mt-1">
                <CurrencyEuroIcon className="w-5 h-5 text-gray-500" />
                <p className="text-gray-600">
                  Enveloppe :{" "}
                  {prospect.enveloppe !== undefined && prospect.enveloppe !== null
                    ? `${prospect.enveloppe} €`
                    : "Non renseignée"}
                </p>
              </div>

              {isPM && (
                <div className="mt-3 space-y-1">
                  <div className="flex items-center gap-2">
                    <BuildingOffice2Icon className="w-5 h-5 text-gray-500" />
                    <p className="text-gray-600">
                      Statut juridique : {prospect.statutJuridique || "N/A"}
                    </p>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-gray-600">SIRET :</span>
                    <span className="text-gray-700">{prospect.siret || "Non renseigné"}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Bouton pour voir la fiche complète */}
          <div className="flex justify-center mt-4">
            <button
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition"
              onClick={() => onViewDetails && onViewDetails(prospect._id)}
            >
              <EyeIcon className="w-5 h-5" />
              Voir la fiche complète
            </button>
          </div>
        </>
      )}
    </div>
  );
}
